var _effectorFileName = "/builds/gmini/front-normalized-tree/src/NormalizedTree.ts";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createDomain } from 'effector';
import { equals } from 'ramda';
import { getRelations } from './getRelations';

/**
 * NormalizedTree
 *
 * TODO: в будущем предстоит избавиться от `TreeItem`. Подразумевается, что
 * `NormalizedTree` перестанет требовать наличия `key` в объектах и станет
 * ожидать передачи в конструктор функции `getKey(value: T): string` и
 * `getParentKey(value: T): null | string`. Это обосновано тем, что объекты не
 * могут хранить в себе ключи их внешних индексов, т.к. их индексирование — не
 * их зона ответственности, и ссылки на один и тот же объект могут содержаться в
 * разных индексах, построенных по разным правилам. В результате `T` избавится
 * от `extends TreeItem` и станет `unknown`.
 */
export var NormalizedTree =
/**
 * Хранит хэш-таблицу объектов TreeItem, где ключ является TreeItem['key'].
 */

/**
 * Содержит связи между сущностями по отношению parentKey -> key.
 * Является стором, значение которого вычисляется на основе значения
 * стора index$.
 */
function NormalizedTree() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 ? arguments[1] : undefined;

  _classCallCheck(this, NormalizedTree);

  _defineProperty(this, "domain", void 0);

  _defineProperty(this, "index$", void 0);

  _defineProperty(this, "relations$", void 0);

  _defineProperty(this, "reset", void 0);

  this.domain = createDomain(options === null || options === void 0 ? void 0 : options.name, {
    sid: "ihsv88"
  });
  this.index$ = this.domain.store(initialState, {
    ɔ: {
      name: 'Index'
    },
    sid: "iyuhmf"
  });
  this.relations$ = this.index$.map(getRelations).map(function (newRelations, oldRelations) {
    return equals(newRelations, oldRelations) ? oldRelations : newRelations;
  });
  this.reset = this.domain.event('reset', {
    sid: "y4ae7s"
  });
};